import React, { useState } from 'react';
import { Save, Settings, CreditCard } from 'lucide-react';

const AdmitSetting = () => {
  const [settings, setSettings] = useState({
    institute_name: '',
    institute_address: '',
    logo_url: '',
    show_photo: true,
    show_signature: true,
    show_barcode: false,
    instructions: 'Please bring this admit card to the examination hall.\nCarry a valid ID proof.\nReach 30 minutes before exam time.',
    footer_text: 'Best Wishes for your Examination'
  });

  const handleSave = () => {
    alert('Admit card settings saved successfully!');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Admit Setting</h1>
          <p className="text-sm text-gray-500 mt-1">Configure admit card template and settings</p>
        </div>
        <button onClick={handleSave} className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
          <Save className="h-4 w-4" />
          Save Settings
        </button>
      </div>

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
        <div className="flex items-start">
          <Settings className="h-5 w-5 text-blue-400 mt-0.5" />
          <div className="ml-3">
            <p className="text-sm text-blue-700">
              These settings will be applied to all generated admit cards. Changes will reflect in future admit card generation.
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6 space-y-4">
          <h3 className="text-lg font-semibold mb-4">Institute Information</h3>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Institute Name *</label>
            <input type="text" className="w-full px-3 py-2 border rounded-lg" value={settings.institute_name} onChange={(e) => setSettings({ ...settings, institute_name: e.target.value })} />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Institute Address</label>
            <textarea rows="3" className="w-full px-3 py-2 border rounded-lg" value={settings.institute_address} onChange={(e) => setSettings({ ...settings, institute_address: e.target.value })} />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Logo URL</label>
            <input type="url" className="w-full px-3 py-2 border rounded-lg" value={settings.logo_url} onChange={(e) => setSettings({ ...settings, logo_url: e.target.value })} placeholder="https://example.com/logo.png" />
          </div>

          <div className="space-y-2">
            <div className="flex items-center">
              <input type="checkbox" id="show_photo" checked={settings.show_photo} onChange={(e) => setSettings({ ...settings, show_photo: e.target.checked })} className="rounded" />
              <label htmlFor="show_photo" className="ml-3 text-sm text-gray-700">Show Student Photo</label>
            </div>
            <div className="flex items-center">
              <input type="checkbox" id="show_signature" checked={settings.show_signature} onChange={(e) => setSettings({ ...settings, show_signature: e.target.checked })} className="rounded" />
              <label htmlFor="show_signature" className="ml-3 text-sm text-gray-700">Show Signature Field</label>
            </div>
            <div className="flex items-center">
              <input type="checkbox" id="show_barcode" checked={settings.show_barcode} onChange={(e) => setSettings({ ...settings, show_barcode: e.target.checked })} className="rounded" />
              <label htmlFor="show_barcode" className="ml-3 text-sm text-gray-700">Show Barcode</label>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6 space-y-4">
          <h3 className="text-lg font-semibold mb-4">Content Settings</h3>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Instructions</label>
            <textarea rows="6" className="w-full px-3 py-2 border rounded-lg" value={settings.instructions} onChange={(e) => setSettings({ ...settings, instructions: e.target.value })} />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Footer Text</label>
            <input type="text" className="w-full px-3 py-2 border rounded-lg" value={settings.footer_text} onChange={(e) => setSettings({ ...settings, footer_text: e.target.value })} />
          </div>

          <div className="bg-gray-50 p-4 rounded-lg mt-6">
            <div className="flex items-center gap-2 mb-2">
              <CreditCard className="h-5 w-5 text-gray-600" />
              <h4 className="font-medium text-gray-900">Preview</h4>
            </div>
            <div className="bg-white p-4 rounded border text-sm">
              <div className="text-center border-b pb-2 mb-2">
                <p className="font-bold">{settings.institute_name}</p>
                {settings.institute_address && <p className="text-xs text-gray-600">{settings.institute_address}</p>}
              </div>
              <p className="text-xs text-gray-600 mb-2">ADMIT CARD</p>
              <div className="text-xs text-gray-600 whitespace-pre-line">{settings.instructions}</div>
              <p className="text-xs text-gray-600 mt-4 text-center italic">{settings.footer_text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmitSetting;